import * as z from "zod";

export const contactInformationSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  phone: z.string().min(7, "Phone number is required").max(20, "Phone number is invalid"),
  profileType: z
    .enum(["none", "business", "personal"], {
      required_error: "Please select a profile type",
    })
    .refine(value => value !== "none", {
      message: "Please select a profile type",
    }),
});

export const businessProfileSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  companyEmail: z.string().email("Please enter a valid email"),
  industry: z.string().min(1, "Please select an industry"),
  purchaseVolume: z
    .string()
    .refine(
      val => !isNaN(Number(val)) && Number(val) > 0,
      "Purchase volume must be a number greater than 0"
    ),
  region: z.string().min(1, "Please select a region"),
  notificationPreferences: z.object({
    email: z.boolean(),
    sms: z.boolean(),
  }),
  purchaseTimeline: z.string().min(1, "Please select a purchase timeline"),
  privacyPolicy: z.boolean().refine(val => val === true, {
    message: "You must accept the privacy policy",
  }),
});

export const personalProfileSchema = z.object({
  personalEmail: z.string().email("Please enter a valid email"),
  productCategories: z.array(z.string()).min(1, "Please select at least one product category"),
  notificationPreferences: z.object({
    email: z.boolean(),
    sms: z.boolean(),
  }),
  purchaseTimeline: z.string().min(1, "Please select a purchase timeline"),
  privacyPolicy: z.boolean().refine(val => val === true, {
    message: "You must accept the privacy policy",
  }),
});

export type ContactInformationFormData = Omit<
  z.infer<typeof contactInformationSchema>,
  "profileType"
> & {
  profileType: "none" | "business" | "personal";
};

export type BusinessProfileFormData = z.infer<typeof businessProfileSchema>;
export type PersonalProfileFormData = z.infer<typeof personalProfileSchema>;
